import { arrayOf, bool, func, shape, string } from 'prop-types'
import { type FC } from 'react'
import {
  connectInfiniteHits,
  connectStateResults,
} from 'react-instantsearch-dom'
import { compose } from 'redux'

import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import { Hits } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Hits'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'
import { hitsType, searchResultsType } from 'views/utils/propTypes/hits'

const InfiniteHits: FC<ComponentProps> = ({ hits, searchResults, ...rest }) => {
  if (!searchResults) {
    return null
  }

  const { index: indexName } = searchResults
  const currentPage = 0
  const hitsPerPage = hits.length
  const queryID = hits[hits.length - 1]?.__queryID

  return (
    <Hits
      {...{ hits, indexName, currentPage, hitsPerPage, queryID, ...rest }}
    />
  )
}

const InfiniteHitsPropTypes = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  hits: arrayOf(shape(hitsType)).isRequired,
  searchResults: shape(searchResultsType).isRequired,
  hasMore: bool.isRequired,
  refineNext: func.isRequired,
  query: string,
  isFilterApplied: bool,
}

const InfiniteHitsDefaultProps = {
  query: '',
  isFilterApplied: false,
}

type ComponentProps = InferPropsWithDefaults<
  typeof InfiniteHitsPropTypes,
  typeof InfiniteHitsDefaultProps
>

export default compose(
  connectInfiniteHits,
  connectStateResults,
  withShopAndRuntimeConfig
)(InfiniteHits)
